import {computed, ref} from 'vue';
import {OpSessionService} from '@/core/services/OpSessionService.js';

const acessarComoOp = ref(false);

export function useOpSession() {
    const isAcessandoComo = computed(() => acessarComoOp.value);

    function updateFromOp(payload) {
        acessarComoOp.value = Boolean(payload.acessarComo);
    }

    function startMonitoring() {
        OpSessionService.getInstance().start(updateFromOp);
    }

    return {
        isAcessandoComo,
        startMonitoring,
    };
}
